export function RemoveIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_332_1451)">
        <circle cx="10" cy="10" r="10" fill="currentColor" fill-opacity="0.3" />
        <path d="M13.999 6L5.99902 14M5.99902 6L13.999 14" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_332_1451">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

RemoveIcon.displayName = 'RemoveIcon';
